<section style="background-color: white;" class="section-container">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-md-9 col-lg-6 col-xl-5 text-center">
        <img [src]="logo()" class="img-fluid mx-auto mt-5 mt-xl-0" alt="Forsyning Online Logo">
        <p class="display-6 mt-3 text-center">{{title()}}</p>
      </div>
      <div class="col-10 col-xs-6 col-md-8 col-lg-6 col-xl-4 offset-xl-1">

        @if (loginPageSettings.allowNemId) {
          <div class="d-grid mt-3">
            <button class="btn btn-primary" (click)="getIdpService('mitid')">{{'MITID' | translation}}</button>
            <div class="alert alert-light mt-3" role="alert">
              <span id="mit-id-info-box">{{ 'MITID_LOGIN_INFO' | translation }}</span>
            </div>
          </div>
        }
        @if (loginPageSettings.allowNemId) {
          <div class="divider d-flex align-items-center my-4">
            <p class="text-center fw-bold mx-3 mb-0">{{'OR' | translation | lowercase}}</p>
          </div>
        }

        <!-- Email input -->
        <div class="form-outline mb-2">
          <label class="form-label" for="form3Example3">{{'USERNAME' | translation}}</label>
          <input [(ngModel)]="username" type="email" id="form3Example3" class="form-control form-control-lg"
            placeholder="{{'USERNAME' | translation}}" />
          </div>

          <!-- Password input -->
          <div class="form-outline mb-2">
            <label class="form-label" for="form3Example4">{{'PASSWORD' | translation}}</label>
            <input [(ngModel)]="password" type="password" id="form3Example4"
              class="form-control form-control-lg" placeholder="{{'PASSWORD' | translation}}"
              (keyup.enter)="login()" />
            </div>

            @if (showForgotPassword()) {
              <div class="text-end">
                <a class="small" [routerLink]="forgotPasswordLink()">{{'FORGOT_PASSWORD' | translation}}</a>
              </div>
            }

            <div class="d-grid my-3">
              <button type="button" class="btn btn-primary" (click)="login()">
                {{'LOGIN' | translation}}
              </button>
              <p class="small fw-bold mt-2 pt-1 mb-0">
                {{'LOGIN_HELP' | translation}}
                <a href="#!" class="link-danger">{{'HELP' | translation}}</a>
              </p>
            </div>

            @if (loginPageSettings.allowQuickConsumption) {
              <div class="divider d-flex align-items-center my-4">
                <p class="text-center fw-bold mx-3 mb-0">{{'OR' | translation | lowercase}}</p>
              </div>
            }

            @if (loginPageSettings.allowQuickConsumption) {
              <div class="d-grid my-4">
                <button class="btn btn-outline-primary"
                  (click)="consumptionService.quickConsumptionReading()">{{'QUICK_CONSUMPTION_READING' |
                  translation}} <i class="fa-solid fa-chevron-right ms-1"></i></button>
                </div>
              }
              <div class="col-6">
                <app-language-selector></app-language-selector>
              </div>
            </div>
          </div>
        </div>
      </section>
